import Wrapper from "../components/Index/Wrapper";
import PopularDishes from "../components/Index/PopularDishes";
import Partners from "../components/Index/Partners";
import Reviews from "../components/Index/Reviews";
import Become from "../components/Index/Become";
import Footer from "../components/Index/Footer";

function Index() {
  return (
    <>
      <Wrapper />
      <PopularDishes />
      <Partners />
      <Reviews />
      <Become />
      <Footer />
    </>
  );
}

export default Index;
